import watch from "../assets/images/mobile.svg";

const Download = () => {
  return (
    <div className="bg-gray-900 sm:h-[50vh]">
      <div className="sm:w-[90%] sm:ml-auto sm:mr-auto sm:flex sm:justify-around items-center sm:pt-6">
        <div className="px-3 py-2 p-3  flex justify-center">
          <img src={watch} alt="" className="h-[300px]" />
        </div>
        <div className=" px-3 py-2">
          <h1 className="text-gray-300 font-extrabold md:text-left text-center py-2 text-xl md:text-3xl max-w-md lg:text-5xl">
            Download your shows to watch offline.
          </h1>

          <p className=" text-gray-300 font-semibold text-base text-center sm:text-left sm:text-2xl max-w-lg">
            Save your favourites easily and always have something to watch.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Download;
